module.exports = __webpack_public_path__ + "img/home-splash-cropped.77983ec8.jpg";